<span *ngIf="shouldShowErrors()" class="{{cssClass}} c-error shake-it">
    <i class="mt-1 c-validation" *ngFor="let error of listOfErrors()">{{error}}</i>
</span>